var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83537 15.2191L9.83511 15.2189L9.8354 15.2186L9.83541 15.2184L9.83554 15.2185L18.3635 7.41939C18.7378 7.08274 18.2818 6.91858 17.7849 7.22393L7.2597 13.9533L2.71339 12.5153C1.73159 12.2106 1.72454 11.5269 2.93382 11.0353L20.6497 4.11246C21.4589 3.74018 22.2398 4.30941 21.931 5.56445L18.9139 19.9726C18.7032 20.9965 18.0928 21.2414 17.247 20.7684L12.6511 17.3274L10.442 19.5043C10.4351 19.5111 10.4281 19.518 10.4212 19.5248C10.1742 19.7685 9.96976 19.9702 9.52245 19.9702L9.83537 15.2191Z",
    fill: "#B5BEED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTelegram);
export default __webpack_public_path__ + "static/media/social-telegram.fbde0f169a224e039e4d7bb057f78708.svg";
export { ForwardRef as ReactComponent };